// Helper function to reliably get price for all products including affiliate products
export const getReliablePrice = (
  product: any,
  withDiscount: boolean = true
): number => {
  // Get the recurring prices array
  const recurringPrices = product?.productOfferingPrice?.recurring || [];

  // If we have recurring prices, use them
  if (recurringPrices.length > 0) {
    // Get the first recurring price (most products only have one)
    const priceObject = recurringPrices[0];

    // If we want to apply discount and it exists
    if (withDiscount && priceObject?.price?.taxIncludedAmountAfterDiscount) {
      return parseFloat(priceObject.price.taxIncludedAmountAfterDiscount) || 0;
    }

    // Otherwise use regular price
    if (priceObject?.price?.taxIncludedAmount) {
      return parseFloat(priceObject.price.taxIncludedAmount) || 0;
    }
  }

  // If no recurring prices, try oneTime prices
  const oneTimePrices = product?.productOfferingPrice?.oneTime || [];
  if (oneTimePrices.length > 0 && oneTimePrices[0]?.price?.taxIncludedAmount) {
    return parseFloat(oneTimePrices[0].price.taxIncludedAmount) || 0;
  }

  // Last resort: try standard method (for backward compatibility)
  const standardPrice = getProductPrice(product, withDiscount);
  if (!isNaN(standardPrice) && standardPrice !== undefined) {
    return standardPrice;
  }

  // Ultimate fallback, return 0
  return 0;
};
